import Common from '../Common';

interface Search {
	limit?: number
	limit_from?: number
	search?: string
	order_by?: string
	order_dir?: string
}

const Companies = class extends Common {
	browse = (search: Search = {}): CustomResponseWithPagination<BrowseResponse & {companies: Company[]}> =>
		this.get(`/companies`, search)
}

export default Companies
